import { render } from "./AnnualReport.vue?vue&type=template&id=36467bdf&scoped=true"
import script from "./AnnualReport.vue?vue&type=script&lang=js"
export * from "./AnnualReport.vue?vue&type=script&lang=js"

import "./AnnualReport.vue?vue&type=style&index=0&id=36467bdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36467bdf"]])

export default __exports__